import React from "react";

// @ts-ignore
import AppStore from "../assets/app-store.svg";

import SEO from "../components/seo";

import LogoImageBG from "../components/LogoImageBg";
import Layout from "../components/layout";
import { Link } from "gatsby";

export const AppStoreDownload = ({ dontVerify }: { dontVerify?: boolean }) => {
  return (
    <Layout
      removeCTA
      fullWidth
      removeFooter
      mainStyle={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <SEO
        title="Download PanoRoom"
        description="Get PanoRoom for your device!"
        verifyAppStoreConnection={!dontVerify}
      />
      <a
        // href="https://apps.apple.com/app/apple-store/id1489359406?pt=120014641&ct=other-apps-ads&mt=8"
        href="https://apps.apple.com/us/app/floor-plan-scanner-panoroom/id1489359406?ppid=da127e3e-0131-4e95-8c33-34c93bd91af5"
        style={{
          width: 300,
          height: "100%",
          placeContent: "center",
          display: "flex",
          gap: 10,
          alignItems: "center",
          flexDirection: "column",
          textDecoration: "none",
        }}
      >
        <LogoImageBG
          style={{ height: 300, width: 300, borderRadius: "10px" }}
        />
        <span
          style={{
            fontFamily:
              '"SF Compact Rounded", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            color: `black`,
            fontWeight: 400,
            fontSize: "32pt",
            marginBottom: 20,
          }}
        >
          PanoRoom
        </span>
        <img src={AppStore} style={{ height: 60, margin: 0 }} />
        <div
          style={{
            marginTop: 20,
            display: "flex",
            gap: 20,
            textDecoration: "underline",
          }}
        >
          <Link
            to={"terms-of-use"}
            style={{ color: "black", textDecoration: "none" }}
          >
            Terms of use
          </Link>
          <Link
            to={"privacy-policy"}
            style={{ color: "black", textDecoration: "none" }}
          >
            Privacy policy
          </Link>
        </div>
      </a>
    </Layout>
  );
};

export default AppStoreDownload;
